"use client";

import { useEffect } from "react";

declare global {
  interface Window {
    hj?: HotjarFunction;
    _hjSettings?: { hjid: number; hjsv: number };
  }

  interface HotjarFunction {
    (...args: any[]): void;
    q?: any[];
  }
}

export default function HotjarDelayed() {
  useEffect(() => {
    const startHotjar = () => {
      if (window._hjSettings) return; // déjà chargé

      window._hjSettings = { hjid: 5174545, hjsv: 6 };

      if (!window.hj) {
        const hjFunc: HotjarFunction = (...args: any[]) => {
          if (!hjFunc.q) hjFunc.q = [];
          hjFunc.q.push(args);
        };
        window.hj = hjFunc;
      }

      const s = document.createElement("script");
      s.async = true;
      s.src = `https://static.hotjar.com/c/hotjar-${window._hjSettings.hjid}.js?sv=${window._hjSettings.hjsv}`;
      document.head.appendChild(s);

      window.removeEventListener("scroll", startHotjar);
      window.removeEventListener("click", startHotjar);
    };

    // différer le chargement jusqu’à interaction utilisateur
    window.addEventListener("scroll", startHotjar, { once: true });
    window.addEventListener("click", startHotjar, { once: true });

    return () => {
      window.removeEventListener("scroll", startHotjar);
      window.removeEventListener("click", startHotjar);
    };
  }, []);

  return null;
}
